/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import Box from 'ui-box';
import { Row, Typography } from 'antd';

const { Title } = Typography

const styles = {
  title: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#404047",
    marginTop: 10
  }
}

const MobileAppointmentHeader = ({icon, title}) => {
  return (
    <Box marginTop={30} marginBottom={24}>
      <Row justify="center">
        {icon}
      </Row>
      <Row justify="center">
        <Title level={4} style={styles.title}>
          {title}
        </Title>
      </Row>
    </Box>
  )
}

MobileAppointmentHeader.defaultProps = {
  title: ''
};

const { string, element } = PropTypes;

MobileAppointmentHeader.propTypes = {
  title: string,
  icon: element
};

export default MobileAppointmentHeader;
